<template>
  <v-dialog v-model="show">
    <v-card>
      <div class="title">SJL WEBシステム ユーザーＩＤ登録用紙</div>
      <span>シャープジャスダロジスティクス株式会社 御中</span>
      <div class="date">
        <div class="dateDay">記入日</div>
        <div class="dateDay">年</div>
        <div class="dateDay">月</div>
        <div class="dateDay">日</div>
      </div>
      <div class="company">
        <div class="companyName">会社名：</div>
        <div class="companyName"></div>
      </div>

      <div class="signPic">
        <div>ＩＤ管理者</div>
      </div>
      <div class="signPic">
        <div>申請者</div>
      </div>

      <div>
        <div class="nameFront">承認者の氏名を記入ください</div>
        <div class="nameBehind">システム管理者が記入します</div>
        <div class="nameFront"></div>
        <div class="nameBehind">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div>
        <div class="nameFront">新規申し込み者の氏名を記入くださ</div>
        <div class="nameBehind">ID管理者のユーザーIDを記入ください</div>
        <div class="nameFront"></div>
        <div class="nameBehind"></div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false
    }
  },
  methods: {
    popup() {
      this.show = true
    }
  }
}
</script>
<style scoped>
.title {
  text-align: center;
  border: 1px solid black;
  margin-left: 10%;
  margin-right: 10%;
}
.date {
  border: 1px solid black;
  width: 20%;
  left: 70%;
  position: relative;
}
.dateDay {
  display: inline;
  margin-right: 8%;
}
.company {
  border: 1px solid black;
  width: 25%;
  left: 70%;
  position: relative;
}
.companyName {
  border: 1px solid black;
  display: inline-block;
}
.signPic {
  border: 1px solid black;
  display: inline-block;
  width: 10%;
  left: 70%;
  position: relative;
  height: 60px;
}
.signPic {
}
.nameFront {
  border: 1px solid black;
  display: inline-block;
  margin-left: 5%;
  width: 45%;
  height: 30px;
  font-size: 18px;
}
.nameBehind {
  border: 1px solid black;
  display: inline-block;
  width: 45%;
  height: 30px;
  font-size: 18px;
}
</style>
